import React from 'react';
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import useFetchData from "../../../form/hooks/use-fetch-data.js";
import {useQuery} from "@tanstack/react-query";
import bosService from "../../../../../../services/web/bos-service.js";
import referralsService from "../../../../../../services/web/referrals-service.js";

const OtherFilters = ({filter, onChange, onChangeCustom}) => {
    const {systemNatures} = useFetchData()

    const {data: boName} = useQuery({
        queryKey: ['boName'],
        queryFn: () => bosService.getBoName(),
        initialData: 'BO'
    });

    const {data: referrals} = useQuery({
        queryFn: () => referralsService.list().then(({data}) => {
            return data.map(d => ({value: d.name, label: d.name}))
        }),
        queryKey: ['referrals'],
    });

    return (
        <SentryRow>
            <div className="col-span-6">
                <SelectComponent
                    id={"article"}
                    value={filter.article}
                    options={systemNatures}
                    label={"Artigos indiciados"}
                    onChange={(value) => onChangeCustom(value?.value, "article")}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id={"individualReferral"}
                    value={filter.individualReferral}
                    options={referrals}
                    label={`Encaminhamento em ${boName}`}
                    onChange={(value) => onChangeCustom(value?.value, "individualReferral")}
                />
            </div>
            <div className="col-span-12">
                <SelectComponent
                    id={"associations"}
                    value={filter.associations}
                    options={[
                        {value: "encounter", label: "Abordagens"},
                        {value: "bo", label: boName},
                        {value: "occ", label: "Ocorrências"},
                        {value: "sos", label: "SOS"},
                    ]}
                    label={"Associações"}
                    onChange={(value) => onChangeCustom(value, "associations")}
                    isMulti
                />
            </div>
        </SentryRow>
    );
};

export default OtherFilters;